"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var group_picker_field_connected_1 = require("../../../experiences/pharmacy-pricing-experience/fields/group-picker-field/group-picker-field.connected");

var group_static_field_1 = require("../../../experiences/pharmacy-pricing-experience/fields/group-static-field/group-static-field");

var theme_1 = require("../../../theming/theme");

var application_header_logo_1 = require("../../app/application-header-logo/application-header-logo");

var header_view_1 = require("../../primitives/header-view");

var label_1 = require("../text/label/label");

var headerStyle = {
  backgroundColor: theme_1.PurpleScale.darkest,
  paddingBottom: 10,
  paddingTop: 25
};
var headerText = {
  display: 'none'
};
var fieldViewStyle = {
  marginBottom: 0,
  marginTop: '1em'
};
var labelTextStyle = {
  color: theme_1.GreyScale.lightest
};

var PricingHeader = function (_super) {
  __extends(PricingHeader, _super);

  function PricingHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PricingHeader.prototype.render = function () {
    return react_1.default.createElement(header_view_1.HeaderView, {
      style: headerStyle
    }, react_1.default.createElement(application_header_logo_1.ApplicationHeaderLogo, null), this.renderPharmacyGroup(), this.renderAccount());
  };

  PricingHeader.prototype.renderPharmacyGroup = function () {
    if (!this.props.showPharmacyGroup) {
      return null;
    }

    if (this.props.isAdmin) {
      return this.renderGroupPicker();
    }

    return this.renderGroupName();
  };

  PricingHeader.prototype.renderGroupPicker = function () {
    return react_1.default.createElement(group_picker_field_connected_1.GroupPickerFieldConnected, {
      viewStyle: fieldViewStyle,
      labelTextStyle: labelTextStyle,
      labelPosition: label_1.LabelPosition.left,
      currentGroup: this.props.currentGroup,
      onSelect: this.props.onGroupSelect
    });
  };

  PricingHeader.prototype.renderGroupName = function () {
    var group = this.props.currentGroup;

    if (!group) {
      return null;
    }

    return react_1.default.createElement(group_static_field_1.GroupStaticField, {
      viewStyle: fieldViewStyle,
      labelTextStyle: labelTextStyle,
      labelPosition: label_1.LabelPosition.left,
      groupName: group.name
    });
  };

  PricingHeader.prototype.renderAccount = function () {
    return react_1.default.createElement(react_native_1.Text, {
      style: headerText
    }, this.props.account ? this.props.account.name : '');
  };

  return PricingHeader;
}(react_1.default.Component);

exports.PricingHeader = PricingHeader;